import {
  DashboardIcon,
  PaymentsIcon,
  PropertiesIcon,
  SettingsIcon,
  UsersIcon,
} from "../assets";
import { SCREEN_PATH } from "./global.constants";

export const navItems = [
  {
    title: "Dashboard",
    path: SCREEN_PATH.ADMIN_DASHBOARD,
    icon: DashboardIcon,
  },
  {
    title: "Users",
    icon: UsersIcon,
    matcher: "/users/",
    children: [
      { title: "Sub Admins", path: SCREEN_PATH.ADMIN_SUB_ADMINS },
      { title: "Agents", path: SCREEN_PATH.ADMIN_AGENTS },
      { title: "Customers", path: SCREEN_PATH.ADMIN_CUSTOMERS },
    ],
  },
  {
    title: "Properties",
    path: SCREEN_PATH.ADMIN_PROPERTIES,
    icon: PropertiesIcon,
  },
  {
    title: "Payment History",
    path: SCREEN_PATH.ADMIN_PAYMENTS,
    icon: PaymentsIcon,
  },
  {
    title: "Settings",
    icon: SettingsIcon,
    matcher: "/settings/",
    children: [
      { title: "Countries", path: SCREEN_PATH.ADMIN_COUNTRIES },
      { title: "Subscription", path: SCREEN_PATH.ADMIN_SUBSCRIPTION },
      { title: "FAQ", path: SCREEN_PATH.ADMIN_FAQ },
      { title: "Privacy Policy", path: SCREEN_PATH.ADMIN_PRIVACY_POLICY },
      {
        title: "Terms and Conditions",
        path: SCREEN_PATH.ADMIN_TERMS_AND_CONDITIONS,
      },
    ],
  },
];

export const agentTabs = {
  CURRENT_LIST: "currentList",
  APPROVALS: "approvals",
};

export const subscriptionTabs = {
  CUSTOMER: "customer",
  AGENT: "agent",
};

export const agentApprovalTabs = {
  PERSONAL_INFO: "PERSONAL_INFO",
  COMPANY_INFO: "COMPANY_INFO",
};

export const agentApprovalStatus = {
  1: "Pending",
  2: "Rejected",
};

export const adminReduxConstants = {
  GET_DASHBOARD_DATA: "GET_DASHBOARD_DATA",
  GET_SUB_ADMINS: "GET_SUB_ADMINS",
  DELETE_SUB_ADMIN: "DELETE_SUB_ADMIN",
  ADD_SUB_ADMIN: "ADD_SUB_ADMIN",
  DELETE_SUB_ADMIN_ADMIN: "DELETE_SUB_ADMIN_ADMIN",
  SUB_ADMINS_PAGINATION: "SUB_ADMINS_PAGINATION",
  GET_CUSTOMERS: "GET_CUSTOMERS",
  GET_CUSTOMER_DETAILS: "GET_CUSTOMER_DETAILS",
  CUSTOMERS_PAGINATION: "CUSTOMERS_PAGINATION",
  GET_AGENTS: "GET_AGENTS",
  GET_APPROVALS: "GET_APPROVALS",
  AGENTS_PAGINATION: "AGENTS_PAGINATION",
  APPROVALS_PAGINATION: "APPROVALS_PAGINATION",
  GET_AGENT_DETAILS: "GET_AGENT_DETAILS",
  GET_AGENT_PROPERTIES: "GET_AGENT_PROPERTIES",
  GET_COUNTRIES_SETTINGS: "GET_COUNTRIES_SETTINGS",
  GET_COUNTRIES_SETTINGS_DETAILS: "GET_COUNTRIES_SETTINGS_DETAILS",
  COUNTRIES_SETTINGS_PAGINATION: "COUNTRIES_SETTINGS_PAGINATION",
  GET_ADMIN_NOTIFICATIONS: "GET_ADMIN_NOTIFICATIONS",
  UPDATE_NOTIFICATION_STATUS: "UPDATE_NOTIFICATION_STATUS",
  GET_FAQS: "GET_FAQS",
  UPDATE_FAQS: "UPDATE_FAQS",
  AGENT_PROPERTIES_PAGINATION: "AGENT_PROPERTIES_PAGINATION",
  GET_CUSTOMERS_EXPORT_ALL_DATA: "GET_CUSTOMERS_EXPORT_ALL_DATA",
  GET_SUB_ADMINS_EXPORT_ALL_DATA: "GET_SUB_ADMINS_EXPORT_ALL_DATA",
  GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA:
    "GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA",
  GET_AGENTS_APPROVALS_EXPORT_ALL_DATA: "GET_AGENTS_APPROVALS_EXPORT_ALL_DATA",
};

export const customerExportHeaders = [
  { key: "id", label: "Customer Id" },
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "defaultCurrency", label: "Currency" },
  { key: "status", label: "Status" },
];

export const subAdminsExportHeaders = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "status", label: "Status" },
];

export const agentCurrentListExportHeaders = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "propertiesCount", label: "Number of Listing" },
  { key: "status", label: "Status" },
];

export const agentApprovalsExportHeaders = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "companyName", label: "Agency Name" },
  { key: "licenseNumber", label: "Licence Number" },
  { key: "approvalStatus", label: "Status" },
];
